<template>
  <div class="level-2-wrap" :class="{ 'light-theme': light, 'w-0': !l2MenuVisibleForStore || !menuShow }" :style="wrapStyle">
    <scrollbar
      class="level-2-menu">
      <!-- 收藏菜单 -->
      <div v-if="staredMenus.length" class="menu-group">{{ $t('common.star_menu') }}</div>
      <div class="level-3-item" v-for="(item, index) of staredMenus" :key="index" @click="routerChange(item)">
        <router-link
          class="menu-item text-truncate pr-2 d-flex align-items-center"
          :to="item.path"
          :title="item.title"
          tag="a"
          active-class="active">
          <icon :type="{ icon: getIcon(item.path), defaultIcon: 'star' }" style="flex: 0 0 14px" />
          <span style="flex: 1 1 auto;margin-left: 5px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ item.title }}</span>
          <icon class="level-item-star" :title="staredMenus.some(m => m.path === item.path) ? $t('common.remove_store') : $t('common.store_to_my_menus')" :type="{ icon: staredMenus.some(m => m.path === item.path) ? 'stared' : 'star' }" style="flex: 0 0 14px" @click.prevent="handleStar(item)" />
        </router-link>
      </div>
      <!-- 关联菜单 -->
      <template v-if="menuList.length">
        <div v-for="(group, index) of menuList" :key="index">
          <div class="menu-group">{{ group.meta.label }}</div>
          <div class="level-3-item" v-for="(item, subIndex) of group.submenus" :key="`${index}-${subIndex}`" @click="routerChange(item)">
            <router-link
              class="menu-item text-truncate pr-2 d-flex align-items-center"
              :to="item.path"
              :title="getMenuLabel(item)"
              tag="a"
              :active-class="staredMenus.some(m => m.path === item.path) ? '' : 'active'">
              <icon :type="{ icon: getIcon(item.path), defaultIcon: 'star' }" style="flex: 0 0 14px" />
              <span style="flex: 1 1 auto;margin-left: 5px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{ getMenuLabel(item) }}</span>
              <icon class="level-item-star" :title="staredMenus.some(m => m.path === item.path) ? $t('common.remove_store') : $t('common.store_to_my_menus')" :type="{ icon: staredMenus.some(m => m.path === item.path) ? 'stared' : 'star' }" style="flex: 0 0 14px" @click.prevent="handleStar(item)" />
            </router-link>
          </div>
        </div>
      </template>
    </scrollbar>
    <div v-if="hasMenuListShow" class="level-2-menu-collapse" @click="$store.commit('setting/SET_L2_MENU_VISIBLE', !l2MenuVisibleForStore)">
      <div class="level-2-menu-collapse-bg" />
      <div class="level-2-menu-collapse-icon d-flex align-items-center">
        <a-icon type="left" style="font-size: 12px;" v-show="l2MenuVisibleForStore" />
        <a-icon type="right" style="font-size: 12px;" v-show="!l2MenuVisibleForStore" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import * as R from 'ramda'
import { hasPermission } from '@/utils/auth'

export default {
  name: 'Level2Menu',
  props: {
    l2Menu: {
      type: Object,
      required: true,
    },
    staredMenus: Array,
    menuList: Array,
    hasMenuListShow: Boolean,
    menuShow: Boolean,
  },
  computed: {
    ...mapGetters(['theme']),
    ...mapState('common', ['openCloudShell', 'cloudShellHeight']),
    wrapStyle () {
      return {
        bottom: this.openCloudShell ? `${this.cloudShellHeight}px` : '0',
      }
    },
    light () {
      return this.theme === 'light'
    },
    menus () {
      const menus = this.l2Menu.menus
      const res = []
      menus.forEach(m2item => {
        const m2 = { ...m2item }
        if (this.showMenu(m2)) {
          if (m2.submenus) {
            let flag = false
            const submenus = []
            m2.submenus.forEach(m3item => {
              if (this.showMenu(m3item)) {
                submenus.push(m3item)
                flag = true
              }
            })
            if (flag) {
              m2.submenus = submenus
              res.push(m2)
            }
          } else {
            res.push(m2)
          }
        }
      })
      return res
    },
    allMenus () {
      const ret = []
      this.menus.map(item => {
        if (item.submenus) {
          ret.push(...item.submenus)
        }
      })
      return ret
    },
    l2MenuVisibleForStore () {
      return this.$store.state.setting.l2MenuVisible
    },
  },
  methods: {
    handleStar (menu) {
      let list = this.staredMenus.map(item => item.path)
      if (list.includes(menu.path)) {
        list = list.filter(item => item !== menu.path)
      } else {
        list.unshift(menu.path)
      }
      this.$store.dispatch('common/updateObject', {
        name: 'sidebar',
        data: {
          staredList: list,
        },
      })
      this.$store.dispatch('profile/update', {
        staredList: list,
      })
    },
    getIcon (path = '') {
      return `res-${path.replace(/\//g, '')}`
    },
    getLabel (meta) {
      if (meta.t) {
        return this.$t(meta.t)
      }
      return R.is(Function, meta.label) ? meta.label() : meta.label
    },
    getMenuHidden (menu) {
      if (!R.isNil(menu.meta.hidden)) {
        if (R.is(Function, menu.meta.hidden)) {
          return menu.meta.hidden(this.userInfo)
        }
        return menu.meta.hidden
      }
      if (!R.isNil(menu.meta.invisible)) {
        if (R.is(Function, menu.meta.invisible)) {
          return menu.meta.invisible(this.userInfo)
        }
        return menu.meta.invisible
      }
      return false
    },
    showMenu (item) {
      const hidden = this.getMenuHidden(item)
      if (R.isNil(item.meta.permission) || R.isEmpty(item.meta.permission)) {
        return !hidden && true
      }
      return !hidden && hasPermission({ key: item.meta.permission })
    },
    routerChange (menu) {
      this.$emit('routerChange', menu, true)
    },
    getMenuLabel (item) {
      if (R.is(Function, item.meta.label)) {
        return item.meta.label()
      }
      return item.meta.label
    },
  },
}
</script>

<style lang="less" scoped>
@import "../../../src/styles/less/theme";

.level-2-wrap {
  position: fixed;
  left: 0;
  width: 160px;
  top: 60px;
  background-color: @sidebar-dark-bg-color;
  box-shadow: 1px 0 6px 0 rgba(165,192,207,.3);
  z-index: 5;
  transition: width .2s ease;
  ::v-deep {
    .scrollbar-wrap {
      overflow-x: hidden;
    }
  }
  &.light-theme {
    background-color: @sidebar-light-bg-color;
    .level-2-menu {
      .title {
        color: #000;
      }
    }
    .menu-group {
      color: #000;
      font-weight: 500;
      margin-top: 15px;
    }
    .level-3-item {
      .level-3-group-title {
        color: #000000;
        font-weight: 500;
      }
      .menu-item {
        position: relative;
        color: @sidebar-light-text-color;
        // &::after {
        //   background-color: @primary-color;
        // }
        &:hover, &.active {
          &::after {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            transform: translate(4px, -50%);
            // background-color: @primary-color;
            overflow: hidden;
          }
        }
        &:hover {
          color: @sidebar-light-hover-text-color;
        }
        &.active {
          color: @primary-color;
        }
      }
    }
  }
  &.w-0 {
    width: 0;
  }
}

.level-2-menu {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: #fff;
  transition: left .2s;
  padding: 12px 0 0 10px;
  .title {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 16px;
  }
}

.level-3-item {
  .group-menu {
    margin-bottom: 10px;
  }
  .level-3-group-title {
    font-size: 14px;
    color: rgba(255, 255, 255, .7);
    line-height: 24px;
    margin-left: 3px;
    margin-bottom: 14px;
    margin-top: 14px;
  }
  .menu-item {
    display: block;
    padding-bottom: 4px;
    padding-top: 6px;
    padding-left: 10px;
    font-size: 14px;
    color: @sidebar-dark-text-color;
    position: relative;
    cursor: pointer;

    // &:hover, &.active {
    //   text-decoration: none;
    //   &::after {
    //     position: absolute;
    //     content: '';
    //     width: 6px;
    //     height: 6px;
    //     border-radius: 50%;
    //     position: absolute;
    //     left: 0;
    //     top: 50%;
    //     transform: translate(4px, -50%);
    //     background-color: @primary-color;
    //     overflow: hidden;
    //   }
    // }
    .level-item-star {
      margin: 0px 5px 0 5px;
      float: right;
      display: none;
    }
    &:hover {
      color: @sidebar-light-hover-text-color;
      font-weight: 500;
      .level-item-star {
        display: block;
      }
    }
    &.active {
      color: @primary-color;
      font-weight: 500;
    }
  }
  > .menu-item {
    margin: 10px 0;
  }
  // & + & {
  //   > .menu-item {
  //     margin-top: 25px;
  //   }
  // }
}
.level-2-menu-collapse {
  position: absolute;
  height: 66px;
  width: 12px;
  top: 50%;
  right: -12px;
  cursor: pointer;
  .level-2-menu-collapse-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-bottom: 8px solid transparent;
    border-right: none;
    border-left: 12px solid #EBEBEB;
    border-top: 8px solid transparent;
    z-index: 1;
  }
  .level-2-menu-collapse-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: transparent;
    color: #C1C1C1;
  }
  &:hover {
    .level-2-menu-collapse-bg {
      border-left-color: #DEDEDE;
    }
    .level-2-menu-collapse-icon {
      color: #888;
    }
  }
}
</style>
